import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";

declare var ko: any;

export class tagTypeSubscriptionsList_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;

    protected getTemplateHtml(): string {

        return /* html */`
            <div class="list-header w-justify" >
                <div class="w-left">
                    <button data-bind="event: { click: onClickAdd }" class="btn secondary icon i-add" type="button">Add Subscription</button>
                </div>

                <div class="w-center">
                    ${ this.filter.getHtmlBuild() }
                </div>

                <div class="w-right">
                    <div id="pagination" class="w-pagination" data-bind="template: { name: 'pagination-template', data: pagination }">
                        <div class="pagination">
                            <input data-bind="value: pageNumber" type="hidden" value="1">
                            <span><a data-bind="event: { click: onClickPageFirst }" class="hidden prev">first</a></span>
                            <ul data-bind="foreach: pages">
                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page active">1</a></li>
                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">2</a></li>
                                <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">3</a></li>
                            </ul>
                            <span><a data-bind="event: { click: onClickPageLast }" class="hidden next">last</a></span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ${ this.resultInfos.getHtmlBuild() }
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'tagTypeDataset.name') }, css: { 'list-sort-desc': orderByAndDirection()=='tagTypeDataset.name_DESC', 'list-sort-asc': orderByAndDirection()=='tagTypeDataset.name_ASC' }">Tag Dataset Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'tagType.name') }, css: { 'list-sort-desc': orderByAndDirection()=='tagType.name_DESC', 'list-sort-asc': orderByAndDirection()=='tagType.name_ASC' }"> Tag Types</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'owner.name') }, css: { 'list-sort-desc': orderByAndDirection()=='owner.name_DESC', 'list-sort-asc': orderByAndDirection()=='owner.name_ASC' }" class="icon i-dropdown-simple">Dataset Owner</span></th>
                            <th></th>
                        </tr>
                    </thead>
                    <!-- ko if: subscriptions() && subscriptions().length > 0 -->
                        <tbody data-bind="foreach: subscriptions">
                            <tr class="cursor" >
                                <td data-bind=""><a class="right-click" data-bind="attr: { href : 'edit/' + id }"><span data-bind="text: name"></span></a></td>
                                <td data-bind=""><a class="right-click" data-bind="attr: { href : 'edit/' + id }"><span data-bind="text: tagTypeNames"></span></a></td>
                                <td data-bind=""><a class="right-click" data-bind="attr: { href : 'edit/' + id }"><span data-bind="attr: { class: owner + ' dark square-icon brand-owner' }" style="width:auto;"></span></a></td>
                                <td data-bind=""><button type="button" class="btn icon border only-icon i-delete" data-bind="event: { click: $parent.onClickDelete }"></button></td>
                            </tr>
                        </tbody>
                    <!-- /ko -->
                    <!-- ko if: !subscriptions() || subscriptions().length == 0 -->
                        <tbody>
                            <tr>
                                <td colspan="4">No Results</td>
                            </tr>
                        </tbody>
                    <!-- /ko -->
                </table>
            </div>
        `;
    }

    protected initPartial(): void {

        this.filter = new filterSimple_template("tagTypeSubscriptions_filter", this.getTemplateViewModel(), this.caller);

        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string {
        return "tagTypeSubscriptionsList-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {

        return {
            subscriptionsArray: ko.observableArray([]),
            subscriptions: ko.pureComputed({
                read: () => this.formatSubscriptions(this.getTemplateViewModel().subscriptionsArray() || []),
                write: (value: Array<any>) => this.getTemplateViewModel().subscriptionsArray(value),
            }),
            idBrand: ko.observable(null),
            onClickAdd: this.onClickAdd.bind(this),
            onClickDelete: this.onClickDelete.bind(this),
            onClickReorder: this.onClickReorder.bind(this),
            orderBy: ko.observable("tagTypeDataset.name"),
            orderByDirection: ko.observable("ASC"),
            orderByAndDirection: ko.observable("tagTypeDataset.name_ASC"),
        };
    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            filters      : {
                keyword : this.filter.getTemplateViewModel().filterKeyword,
            },
        }
    }

    private formatSubscriptions(subscriptions) {
        return subscriptions.map((dataset) => {
            return {
                id: dataset.id,
                name: dataset.name,
                tagTypeNames: dataset.tagTypes.map((tagType) => {
                    return ` ${tagType.name}`
                }),
                owner: dataset.tagTypes[0].brandOwner ? dataset.tagTypes[0].brandOwner.iconImage : ""
            }
        });
    }

    public onClickAdd() {
        this.caller.add();
    }

    public onClickDelete(dataset) {
        if(confirm('Are you sure you want to delete this subscription set?')){
            this.caller.delete(dataset);
        }
    }

    public onClickReorder(value, data, event) {
        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.tagsListReorder();
    }

    public setIdBrand(idBrand): void {

        this.getTemplateViewModel().idBrand(idBrand);
    }

    public setResultInfo(nbResults, nbPages, execTime) {
        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/tagTypeSubscriptionsList_template.ts